<nav>
  <ul class="mainHeader__mainNav" role="menubar">
    <ng-container *ngFor="let level2 of mainNav; let ii = index">
      <li
        #ref
        class="mainNav__level2"
        role="menuitem"
        [ngClass]="{active: level2.active, 'd-none': level2.mnemonic === 'direct-shipping' && !directShippingEligible}"
        (mouseover)="mouseoverUnderline(ii); applyActiveState(level2)"
        (mouseout)="mouseoutUnderline(); applyActiveState(level2, false)"
      >
        <!-- LVL2-->
        <!-- if mobile -->
        <ng-container *ngIf="!deviceIsLgUp; else level2LgUp">
          <ng-container *ngIf="level2.children && level2.children.length > 0; else titleWithoutLevel3">
            <ng-container *ngIf="level2.url !== '#'; else titleWithoutUrlMobile">
              <!-- use checkbox to simulate click -->
              <input
                class="open__level2"
                type="radio"
                id="{{ level2.label }}"
                hidden
                name="label"
                (click)="checkInput($event, 'radioCheckedLevel1')"
              />
              <vc-ref
                onclick="this.previousElementSibling.checked = !this.previousElementSibling.checked"
                [resource]="level2.url"
                [anchor]="!level2.anchor"
                class="mainNav__level2__title"
                [lang]="setLanguageAttribute(level2.label)"
                [isNavMenu]="true"
                [ngClass]="{
                  'mainNav__title__arrows-xs': level2.children && level2.children.length > 0,
                  'mainNav__level2__title--event': eventMnemonics.includes(level2.mnemonic)
                }"
              >
                <label for="{{ level2.label }}">
                  <span class="underlineActive-xs">{{ level2.label }}</span>
                </label>
              </vc-ref>
            </ng-container>
          </ng-container>
        </ng-container>

        <ul
          *ngIf="level2.children && level2.children.length > 0"
          class="mainNav__level2__content"
          role="menu"
          [ngClass]="{active: level2.active}"
        >
          <li
            *ngFor="let level3 of level2.children; let iii = index"
            class="mainNav__level3"
            [ngClass]="{'mainNav__level3--brands': level2.mnemonic == 'designers'}"
            role="menuitem"
            (click)="resetCatalogPage()"
          >
            <ng-container *ngIf="!deviceIsLgUp; else level3LgUp">
              <input
                class="open__level3"
                type="radio"
                id="{{ level2.label + level3.label }}"
                hidden
                name="label2"
                (click)="checkInput($event, 'radioCheckedLevel2')"
              />
              <label
                for="{{ level2.label + level3.label }}"
                class="mainNav__level3__title"
                [ngClass]="{
                  'mainNav__title__arrows-xs': level3.children.length > 0
                }"
              >
                <span class="underlineActive-xs">{{ level3.label }}</span>
              </label>
            </ng-container>

            <ng-template #level3LgUp>
              <vc-ref
                [resource]="deviceIsLgUp ? level3.url : ''"
                [anchor]="!level3.anchor"
                class="mainNav__level3__title"
                [lang]="setLanguageAttribute(level3.label)"
                [isNavMenu]="true"
                [ngClass]="{
                  'mainNav__title__arrows-xs': level3.children.length > 0
                }"
              >
                <span class="underlineActive-xs">{{ level3.label }}</span>
              </vc-ref>
            </ng-template>

            <ul
              *ngIf="level3.children"
              class="mainNav__level3__content"
              [ngClass]="{active: level3.active}"
              role="menu"
            >
              <li *ngFor="let level4 of level3.children; let iiii = index" role="menuitem">
                <vc-ref
                  [isBlock]="true"
                  [resource]="level4.url"
                  [anchor]="!level4.anchor"
                  class="mainNav__level4__title"
                  [lang]="setLanguageAttribute(level4.label)"
                  [isNavMenu]="true"
                  [ngClass]="{
                    'mainNav__level4__title--comingSoon': level4.id == '1006',
                    'mainNav__level4__title--allBrands': level4.id == '1057'
                  }"
                  [attr.data-tag]="level4.id == '1006' ? 'Premium' : ''"
                  (click)="closeMenu()"
                >
                  {{ level4.label }}
                </vc-ref>
              </li>
            </ul>
          </li>
        </ul>

        <!-- TEMPLATES -->
        <ng-template #titleWithoutUrlMobile>
          <input
            class="open__level2"
            type="radio"
            id="{{ level2.label }}"
            hidden
            name="label"
            (click)="checkInput($event, 'radioCheckedLevel1')"
          />
          <label
            for="{{ level2.label }}"
            class="mainNav__level2__title"
            [ngClass]="{
              'mainNav__title__arrows-xs': level2.children && level2.children.length > 0,
              'mainNav__level2__title--event': eventMnemonics.includes(level2.mnemonic)
            }"
          >
            <span class="underlineActive-xs">{{ level2.label }}</span>
          </label>
        </ng-template>
        <!-- if DESKTOP -->
        <ng-template #level2LgUp>
          <ng-container *ngIf="level2.url !== '#'; else titleWithoutUrl">
            <div class="mainNav__level2__accessibilityWrapper">
              <vc-ref
                [resource]="level2.url"
                [anchor]="!level2.anchor"
                class="mainNav__level2__title"
                [lang]="setLanguageAttribute(level2.label)"
                [isNavMenu]="true"
                [ngClass]="{
                  'mainNav__title__arrows-xs': level2.children && level2.children.length > 0,
                  'mainNav__level2__title--event': eventMnemonics.includes(level2.mnemonic)
                }"
              >
                <span class="underlineActive-xs">{{ level2.label }}</span>
              </vc-ref>
              <ng-container *ngTemplateOutlet="accessibilityOpenButton"></ng-container>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #titleWithoutLevel3>
          <ng-container *ngIf="level2.url !== '#'; else titleWithoutUrl">
            <vc-ref
              [resource]="level2.url"
              [anchor]="!level2.anchor"
              class="mainNav__level2__title"
              [lang]="setLanguageAttribute(level2.label)"
              [isNavMenu]="true"
              [ngClass]="{
                'mainNav__title__arrows-xs': level2.children && level2.children.length > 0,
                'mainNav__level2__title--event': eventMnemonics.includes(level2.mnemonic)
              }"
              (click)="closeMenu()"
            >
              <span class="underlineActive-xs">{{ level2.label }}</span>
            </vc-ref>
          </ng-container>
        </ng-template>
        <ng-template #titleWithoutUrl>
          <div class="mainNav__level2__accessibilityWrapper">
            <button
              class="mainNav__level2__title mainNav__level2__title--notLink"
              [ngClass]="{
                'mainNav__title__arrows-xs': level2.children && level2.children.length > 0
              }"
            >
              <span class="underlineActive-xs">{{ level2.label }}</span>
            </button>
            <ng-container *ngTemplateOutlet="accessibilityOpenButton"></ng-container>
          </div>
        </ng-template>

        <ng-template #accessibilityOpenButton>
          <button
            *ngIf="level2.children && level2.children.length > 0"
            class="mainNav__level2__accessibilityOpen"
            [attr.aria-haspopup]="true"
            [attr.aria-expanded]="level2.children && level2.children.length > 0 ? level2.active : null"
            [lang]="setLanguageAttribute(level2.label)"
            (click)="applyActiveState(level2, !level2.active)"
          >
            <span *ngIf="!level2.active" i18n="@@HEADER.NAVIGATION.ACCESSIBILITY.OPEN">open</span>
            <span *ngIf="level2.active" i18n="@@HEADER.NAVIGATION.ACCESSIBILITY.CLOSE">close</span>
            <span> {{ level2.label }} </span>
            <vc-sprite-icons name="arrow-head-down"></vc-sprite-icons>
          </button>
        </ng-template>

        <!-- END TEMPLATES -->
      </li>
    </ng-container>
    <li vcUnderline aria-hidden="true"></li>
  </ul>
</nav>
